import { TransactionService } from '@/services/transactionService'

export const TEST_DEPOSIT_AMOUNT = 500

/**
 * Staging backends allow creating draft deposits without a physical bill
 * acceptor. Production APIs reject that path, so the on-page control is
 * gated on the configured API host rather than debug mode.
 */
export function isTestCashDepositEnabled(): boolean {
    const apiUrl = import.meta.env.VITE_API_URL ?? ''
    return /staging/i.test(apiUrl)
}

export async function simulateTestDeposit(
    amount = TEST_DEPOSIT_AMOUNT
): Promise<void> {
    await TransactionService.CreateDeviceDraftDeposit({ amount })
}
